import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TransactionService } from "../../shared/services/transaction.service";
import { ToastrService } from "ngx-toastr";
import {AdminService} from '../../shared/services/admin.service';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { TopbarComponent } from "../../shared/components/topbar/topbar.component";
import { SidebarComponent } from "../../shared/components/sidebar/sidebar.component";
import { BottombarComponent } from "../../shared/components/bottombar/bottombar.component";

@Component({
    selector: "app-transaction-details",
    templateUrl: "./transaction-details.component.html",
    styleUrls: ["./transaction-details.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
    ]
})
export class TransactionDetailsComponent implements OnInit {
  transaction: any;
  isRetrying = false;
  showModal = false;
  details;
  editData = {
    beneficiary_bank_account_number: "",
    beneficiary_bank_account_name: "",
    beneficiary_bank_name: "",
  };

  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private transactionService: TransactionService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getDetails();
    this.route.paramMap.subscribe((params) => {
      const transactionRef = params.get("transaction_ref");
      this.getTransaction(transactionRef);
    });
  }

  getTransaction(transactionRef: string) {
    this.transactionService.get(transactionRef).subscribe(
      (data) => {
        this.transaction = data;
        try {
          this.cdr.detectChanges();
        } catch (e) { void e; }
      },
      (error) => this.toastr.error("Failed to load transaction")
    );
  }

  openModal() {
    console.log("Opening modal for transaction edit", this.transaction);
    this.editData = {
      beneficiary_bank_account_number: this.transaction
        ? this.transaction.beneficiary_bank_account_number
        : "",
      beneficiary_bank_account_name: this.transaction
        ? this.transaction.beneficiary_bank_account_name
        : "",
      beneficiary_bank_name: this.transaction
        ? this.transaction.beneficiary_bank_name
        : "",
    };

    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  submitEdit() {
    console.log("Updated info:", this.editData);
    this.showModal = false;
    this.transactionService
      .editTransaction(this.transaction.transaction_ref, this.editData)
      .subscribe(
        (res) => {
          this.toastr.success("Transaction updated!");
          this.getTransaction(this.transaction.transaction_ref);
        },
        (err) => this.toastr.error("Update failed")
      );
  }

  retryTransaction(transaction_ref: string) {
    this.isRetrying = true;
    this.transactionService.retryTransaction(transaction_ref).subscribe(
      (data) => {
        this.isRetrying = false;
        if (data.status === 200) {
          this.toastr.success("Transaction retried successfully");
          this.getTransaction(transaction_ref);
        } else {
          this.toastr.error("Failed to retry transaction");
        }
      },
      (error) => {
        this.isRetrying = false;
        this.toastr.error("An error occurred while retrying the transaction");
      }
    );
  }

   getDetails() {
    this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
        try {
          this.cdr.detectChanges();
        } catch (e) { void e; }
      });
  }
}
